
    <div class="d-flex" [class.toggled]="value" id="wrapper">
        <div id="page-content-wrapper">
            <div class="container-fluid">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>